module.exports = __webpack_public_path__ + "static/media/studio-5.ef5c30ea.jpg";